import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ConnectionService } from '../service/connection.service';
import { SwalService } from '../service/swal.service';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-feedback',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css'],
})
export class FeedbackComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  alreadySubmitted = false;

  priceRanges = [
    { id: 'free', label: 'Gratis' },
    { id: '1-5', label: '€1 – €5 / mese' },
    { id: '5-10', label: '€5 – €10 / mese' },
    { id: '10-20', label: '€10 – €20 / mese' },
    { id: '20+', label: '€20+ / mese' },
  ];

  features = [
    { id: 'contracts', label: 'Generazione contratti' },
    { id: 'calendar', label: 'Calendario matrimoni' },
    { id: 'clients', label: 'Scheda cliente' },
    { id: 'photos', label: 'Galleria foto' },
    { id: 'team', label: 'Gestione team' },
    { id: 'costs', label: 'Gestione costi' },
    { id: 'pdf', label: 'PDF personalizzati' },
  ];

  npsScore: number | null = null;
  npsLabels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  constructor(
    private fb: FormBuilder,
    private connection: ConnectionService,
    private swal: SwalService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      nps: [null, Validators.required],
      interested_subscription: [null, Validators.required],
      price_range: [null],
      useful_features: [[]],
      missing_features: [''],
    });

    this.connection.get(
      'feedback/has-submitted',
      (res: any) => {
        // se res è l'oggetto feedback già compilato, precompila il form
        if (res && typeof res === 'object') {
          this.alreadySubmitted = true;
          this.npsScore = res.nps;
          this.form.patchValue(res);
        }
      },
      () => {},
    );
  }

  submit() {
    if (this.form.invalid) {
      this.swal.error('Compila tutti i campi obbligatori');
      return;
    }
    // usa PUT se già esiste, POST se nuovo
    const method = this.alreadySubmitted ? 'put' : 'post';
    this.connection[method](
      'feedback',
      this.form.value,
      () => {
        this.submitted = true;
        this.alreadySubmitted = false; // mostra il thank-you "submitted now"
      },
      () => this.swal.errorDialog('Errore', 'Invio feedback fallito'),
    );
  }

  setNps(score: number) {
    this.npsScore = score;
    this.form.patchValue({ nps: score });
  }

  toggleFeature(id: string) {
    const current: string[] = this.form.value.useful_features ?? [];
    const updated = current.includes(id)
      ? current.filter((f) => f !== id)
      : [...current, id];
    this.form.patchValue({ useful_features: updated });
  }

  isFeatureSelected(id: string): boolean {
    return (this.form.value.useful_features ?? []).includes(id);
  }
}
